import React, { useState } from "react";

import { getDatabaseHeading } from "../../helpers/nameHelpers";

import moment from "moment";

import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";

import { Dialog } from "../../hooks/useDialog";

import { openConfirm } from "../../components/confirmBox/ConfirmBox";

import CircularProgress from "@material-ui/core/CircularProgress";

import "react-table/react-table.css";

import styled from "styled-components";

const TF = (props) => {
  const [value, value_set] = useState(props.value);

  return (
    <div style={{ margin: 10, width: 250 }}>
      <TextField
        fullWidth
        value={value}
        label={props.label}
        variant="outlined"
        onChange={(e) => {
          if (!isNaN(e.target.value)) value_set(e.target.value.trim());
        }}
        onBlur={(e) => {
          if (value !== props.value) props.onChange(value);
        }}
      />
    </div>
  );
};

const builderData = [
  {
    type: "oneMonthTbillNominalYield",
    heading: "BofC 1-mo Tbill nominal Yield",
    heading2: "1-mo Tbill nominal Yield",
  },
  {
    type: "oneMonthTbillRet",
    heading: "BofC 1-mo Tbill Ret",
    heading2: "1-mo Tbill Ret",
  },
  { type: "closingDate", heading: "Closing Date", heading2: "Closing Date" },
  {
    type: "exchangeRate",
    heading: "FX Rate",
    heading2: "Trade-Weighted USD Index Daily",
  },
  { type: "secondaryIndex", heading: "S&P500 CAD", heading2: "FTSE Return" },
  {
    type: "tenYearBondReturn",
    heading: "10 yr Govt Bond Ret",
    heading2: "10 yr Treasury Bond Ret",
  },
  {
    type: "tenYearGovernmentBondYieldAnnualized",
    heading: "10-YR BM Gov't Bond Yield annualized",
    heading2: "Const 10yr Mat Yield",
  },
  { type: "mainIndex", heading: "TSX Composite", heading2: "S&P500 USD" },
  { type: "vix", heading: "VIX at Date", heading2: "VIX at Date" },
  { type: "valueReturn", heading: "Value  Return", heading2: "Value  Return" },
  { type: "growthReturn", heading: "Growth Return", heading2: "Growth Return" },
  {
    type: "ftseWorldCAD",
    heading: "FTSE World CAD",
    heading2: "",
    excludeCurrencies: ["USD"],
  },
  {
    type: "unemploymentRate",
    heading: "Unemployment Rate",
    heading2: "Unemployment Rate",
  },
  {
    type: "cpiInflation",
    heading: "CPI Inflation",
    heading2: "CPI Inflation",
  },
  {
    type: "goldETF",
    heading: "Gold ETF HUG.TO Return (CAD)",
    heading2: "SPDR Gold Shares (GLD) Return",
  },
];

function getBuilder(databaseCurrency) {
  return builderData.filter(
    (e) =>
      !e.excludeCurrencies || e.excludeCurrencies.indexOf(databaseCurrency) < 0,
  );
}

const buildDB = (data, databaseCurrency) => {
  const ret = [];

  const rows = data.split("\n");

  var builder = getBuilder(databaseCurrency);

  var isCancel = false;

  rows
    .filter((e) => e.trim())
    .forEach((row, i) => {
      var cols = row.split("\t");

      //build the indexes for cols
      if (i === 0) {
        cols.forEach((col, colIndex) => {
          var found = builder.find(
            (e) =>
              (databaseCurrency === "CAD" && e.heading === col) ||
              (databaseCurrency === "USD" && e.heading2 === col),
          );

          if (found) {
            found.index = colIndex;
          }
        });
      } else if (!isCancel) {
        if (builder.find((e) => e.index === -1)) {
          isCancel = true;
          var message = "The following columns are missing:\r\n";

          builder
            .filter((e) => e.index === -1)
            .forEach((e) => {
              message += ` - ${
                databaseCurrency === "CAD" ? e.heading : e.heading2
              }\r\n`;
            });

          alert(message);
        } else {
          var rowData = {};
          var save = true;

          rowData["currencyType"] = databaseCurrency;

          cols.forEach((col, colIndex) => {
            var found = builder.find((e) => e.index === colIndex);

            if (found) {
              if (found.type === "closingDate") {
                rowData[found.type] = moment(new Date(col)).format(
                  "YYYY-MM-DDT00:00:00",
                );
              } else {
                rowData[found.type] = col ? parseFloat(col) : "";

                if (!col) save = false;
              }
            }
          });

          if (save) ret.push(rowData);
        }
      }
    });

  return ret;
};

const Main = (props) => {
  const { adminActions, adminState } = props;

  const { database = [], databaseSaving } = adminState;

  const [editItem, editItem_set] = useState();
  const [editItem2, editItem2_set] = useState();

  const [newDBValue, newDBValue_set] = useState("");
  const [compareValue, compareValue_set] = useState("");

  const [databaseCurrency, databaseCurrency_set] = useState("");

  const [showImport, showImport_set] = useState(false);
  const [showHelp, showHelp_set] = useState(false);

  const [showDatabaseSaved, showDatabaseSaved_set] = useState(false);

  React.useEffect(() => {
    if (databaseCurrency) {
      adminActions.fetchDatabase(databaseCurrency);
    }
  }, [databaseCurrency]);

  if (adminState.loading) {
    return <div>Loading...</div>;
  }

  // if (database.length === 0) {
  //     return <div>No Items</div>
  // }

  const itemNames = [
    "mainIndex",
    "secondaryIndex",
    "tenYearBondReturn",
    "exchangeRate",
    "oneMonthTbillRet",
    "oneMonthTbillNominalYield",
    "tenYearGovernmentBondYieldAnnualized",
    "vix",
    "valueReturn",
    "growthReturn",
  ];

  if (databaseCurrency === "CAD") {
    itemNames.push("ftseWorldCAD");
  }

  itemNames.push("unemploymentRate");
  itemNames.push("cpiInflation");
  itemNames.push("goldETF");

  var sorted = database
    .sort((a, b) => (a.closingDate > b.closingDate ? 1 : -1))
    .slice();

  var date = new Date(sorted[0] && sorted[0].closingDate);
  date.setDate(date.getDate() + 1);
  date.setMonth(date.getMonth() - 1);
  date.setDate(date.getDate() - 1);

  const minRow = {
    closingDate: moment(date).format("YYYY-MM-DDT00:00:00"),
  };

  sorted.unshift(minRow);

  date = new Date(sorted[sorted.length - 1].closingDate);
  date.setDate(date.getDate() + 1);
  date.setMonth(date.getMonth() + 1);
  date.setDate(date.getDate() - 1);

  const maxRow = {
    closingDate: moment(date).format("YYYY-MM-DDT00:00:00"),
  };

  sorted.push(maxRow);

  const columns = [
    {
      Header: "",
      accessor: "",
      Cell: (props) => {
        return (
          <Button
            color={"primary"}
            onClick={() => {
              // editItem_set(props.value.closingDate);
              editItem_set({ ...props.value });
              editItem2_set({ ...props.value });
            }}
          >
            {maxRow === props.value || minRow === props.value ? "Add" : "Edit"}
          </Button>
        );
      },
    },
    {
      Header: "Closing Date",
      accessor: "closingDate",
      Cell: (props) => <span>{moment(props.value).format("YYYY-MMM-DD")}</span>,
    },
  ];

  itemNames.forEach((element) => {
    columns.push({
      Header: getDatabaseHeading(element, databaseCurrency),
      accessor: element,
      Cell: (props) => <span>{props.value}</span>,
    });
  });

  itemNames.forEach((element) => {
    maxRow[element] = "";
    minRow[element] = "";
  });

  const comparables = [];

  var builder = getBuilder(databaseCurrency);

  if (compareValue && compareValue.length > 0) {
    compareValue.forEach((element) => {
      var x = { closingDate: element.closingDate };

      var existing = database.find(
        (e) =>
          moment(e.closingDate).format("YYYY-MM-DDT00:00:00") === x.closingDate,
      );

      builder
        .filter((e) => e.type !== "closingDate")
        .forEach((bitem) => {
          x[bitem.type] = { newValue: element[bitem.type] };

          if (existing) {
            x[bitem.type].oldValue = existing[bitem.type];
          }
        });

      comparables.push(x);
    });

    var tmp = comparables.map((e) => e.closingDate);

    database
      .filter((e) => tmp.indexOf(e.closingDate) < 0)
      .forEach((element) => {
        var x = { closingDate: element.closingDate };

        builder
          .filter((e) => e.type !== "closingDate")
          .forEach((bitem) => {
            x[bitem.type] = { oldValue: element[bitem.type] };
          });

        comparables.push(x);
      });
  }

  return (
    <div
      style={{
        width: 2000,
      }}
    >
      {databaseSaving && (
        <div>
          <Dialog actionButtons={[]}>
            <div>
              <CircularProgress />
            </div>
            <div>Saving...</div>
          </Dialog>
        </div>
      )}
      {!databaseSaving && showDatabaseSaved && (
        <Dialog
          onClose={() => {
            adminActions.fetchDatabase(databaseCurrency);
            showDatabaseSaved_set(false);
          }}
        >
          Database Saved.
        </Dialog>
      )}

      <div style={{ width: 300 }}>
        <TextField
          fullWidth
          select
          value={databaseCurrency}
          label={"Portfolio’s Home Currency"}
          onChange={(e, v) => {
            databaseCurrency_set(e.target.value);
          }}
        >
          <MenuItem value={"CAD"}>CAD</MenuItem>
          <MenuItem value={"USD"}>USD</MenuItem>
        </TextField>
      </div>
      {!databaseCurrency && (
        <div style={{ marginTop: 20 }}>
          <div style={{ fontSize: 16 }}>No currency selected</div>
        </div>
      )}
      {databaseCurrency && (
        <div style={{ marginTop: 20 }}>
          <div style={{ fontSize: 20, marginBottom: 20 }}>Database Entry</div>
          <div style={{ marginBottom: 20 }}>
            <Button
              onClick={() => {
                showImport_set(true);
                newDBValue_set("");
              }}
              color="primary"
              variant="outlined"
            >
              Import Values from Excel
            </Button>
          </div>
          {showImport && (
            <Dialog
              options={{ maxWidth: "md", fullWidth: true }}
              actionButtons={[
                <Button
                  color={"primary"}
                  disabled={!newDBValue}
                  onClick={() => {
                    var tmp = buildDB(newDBValue, databaseCurrency);

                    if (tmp.length > 0) compareValue_set(tmp);
                  }}
                >
                  Import
                </Button>,
                <Button
                  color={"secondary"}
                  onClick={() => {
                    showImport_set(false);
                  }}
                >
                  Cancel
                </Button>,
              ]}
            >
              <div style={{ border: "1px solid black" }}>
                <TextField
                  inputProps={{ style: { whiteSpace: "nowrap" } }}
                  fullWidth
                  multiline
                  rows={20}
                  value={newDBValue}
                  onChange={(e) => newDBValue_set(e.target.value)}
                />
              </div>
              <div style={{ margin: 20 }}>
                <Button
                  color={"primary"}
                  variant="outlined"
                  onClick={() => {
                    showHelp_set(true);
                  }}
                >
                  Instructions
                </Button>
              </div>
            </Dialog>
          )}
          {showHelp && (
            <Dialog
              options={{ maxWidth: "md", fullWidth: true }}
              onClose={() => showHelp_set(false)}
            >
              <div>
                <div>
                  This tool allows you to replace the entire database values
                  with data copied from the excel master.
                </div>
                <div>
                  How to use:
                  <ol>
                    <li>
                      Format the excel cells you will copy to have be a number
                      (not percentage) and at least 15 decimal places .
                    </li>
                    <li>
                      Starting from the heading row, copy all the cells upto the
                      last date to import. Make sure to include the date column.
                    </li>
                    <li>
                      Paste the values in the textbox provided and click the
                      Import button.
                    </li>
                    <li>
                      You will then be shown the changes that will be applied.
                      Click Save to import the data.
                    </li>
                  </ol>
                </div>
                <div>
                  <b>Important:</b> This will replace all the data for this
                  currency type, so be careful.
                </div>
              </div>
            </Dialog>
          )}
          {editItem && (
            <Dialog
              title={"Edit Database Value"}
              options={{ maxWidth: "md", fullWidth: true }}
              actionButtons={[
                <Button
                  onClick={() => {
                    if (JSON.stringify(editItem) !== JSON.stringify(editItem2))
                      adminActions.saveDatabaseItem({
                        ...editItem,
                        currencyType: databaseCurrency,
                      });
                    editItem_set(null);
                  }}
                >
                  Save
                </Button>,
                <Button
                  onClick={() => {
                    editItem_set(null);
                  }}
                >
                  Cancel
                </Button>,
              ]}
            >
              <div>
                <div>
                  Date: {moment(editItem.closingDate).format("YYYY-MM-DD")}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {itemNames.map((e, i) => (
                    <div key={`${i}${e}`}>
                      <TF
                        value={editItem[e]}
                        onChange={(v) => {
                          editItem_set({ ...editItem, [e]: v });
                        }}
                        label={getDatabaseHeading(e, databaseCurrency)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Dialog>
          )}
          {compareValue && (
            <Dialog
              title={""}
              options={{ maxWidth: "lg", fullWidth: true }}
              actionButtons={[
                <Button
                  onClick={() => {
                    openConfirm({
                      title: "Confirm Import",
                      description:
                        "Are you sure you want to overwrite existing database?",
                      callback: () => {
                        adminActions.SetDatabase({
                          databaseString: JSON.stringify(compareValue, null, 2),
                          currency: databaseCurrency,
                        });
                        showDatabaseSaved_set(true);
                        showImport_set(false);
                        compareValue_set(false);
                      },
                    });
                  }}
                >
                  Save
                </Button>,
                <Button
                  onClick={() => {
                    compareValue_set("");
                  }}
                >
                  Cancel
                </Button>,
              ]}
            >
              <div style={{ fontSize: 14 }}>
                <table>
                  <thead>
                    <tr>
                      {builder
                        .sort((a, b) =>
                          a.index > b.index ? 1 : a.index < b.index ? -1 : 0,
                        )
                        .map((e, i) => (
                          <th key={`asd_${i}`}>
                            {databaseCurrency === "CAD"
                              ? e.heading
                              : e.heading2}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {comparables
                      .sort((a, b) =>
                        a.closingDate > b.closingDate
                          ? 1
                          : a.closingDate < b.closingDate
                            ? -1
                            : 0,
                      )
                      .map((f) => (
                        <tr key={`oo_${f.closingDate}`}>
                          {builder
                            .sort((a, b) =>
                              a.index > b.index
                                ? 1
                                : a.index < b.index
                                  ? -1
                                  : 0,
                            )
                            .map((e, i) => (
                              <td key={`aswd_${i}_${f.closingDate}`}>
                                {e.type === "closingDate" && (
                                  <div>
                                    {moment(f.closingDate).format(
                                      "YYYY-MMM-DD",
                                    )}
                                  </div>
                                )}
                                {e.type !== "closingDate" && (
                                  <div>
                                    {f[e.type] &&
                                      f[e.type].newValue ===
                                        f[e.type].oldValue && (
                                        <div>{f[e.type].newValue}</div>
                                      )}
                                    {f[e.type] &&
                                      f[e.type].newValue !==
                                        f[e.type].oldValue && (
                                        <div>
                                          <div style={{ color: "green" }}>
                                            {f[e.type].newValue}
                                          </div>
                                          <div style={{ color: "red" }}>
                                            {f[e.type].oldValue}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                )}
                              </td>
                            ))}
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div>
                  <TextField
                    value={JSON.stringify(compareValue, null, 2)}
                    multiline
                    fullWidth
                  ></TextField>
                </div>
              </div>
            </Dialog>
          )}
          <div style={{ display: "flex" }}>
            {columns.map((e, i) => (
              <ColumnHeading
                key={e.Header}
                style={
                  i === 0
                    ? {
                        width: 100,
                      }
                    : {}
                }
              >
                {e.Header}
              </ColumnHeading>
            ))}
          </div>
          {sorted.map((row, rowI) => (
            <div key={`row_${rowI}`} style={{ display: "flex" }}>
              {columns.map((col, colI) => (
                <ColumnCell
                  key={`col_${colI}_${rowI}`}
                  title={
                    colI === 0 ? "" : `${col.Header} - ${row[col.accessor]}`
                  }
                  style={
                    colI === 0
                      ? {
                          width: 100,
                        }
                      : {}
                  }
                >
                  {colI === 0 && (
                    <div>
                      {(rowI === 0 || rowI === sorted.length - 1) && (
                        <div>
                          <Button
                            color="primary"
                            onClick={() => {
                              // editItem_set(props.value.closingDate);
                              editItem_set({ ...row });
                              editItem2_set({ ...row });
                            }}
                          >
                            Add
                          </Button>
                        </div>
                      )}
                      {/* {(rowI !== 0 && rowI !== sorted.length) && <div>
                            <Button color='primary' onClick={() => {
                                // editItem_set(props.value.closingDate);
                                editItem_set({ ...props.value });
                                editItem2_set({ ...props.value });
                            }}>Edit</Button>
                        </div>} */}
                    </div>
                  )}
                  {col.accessor === "closingDate"
                    ? moment(row[col.accessor]).format("YYYY-MM-DD")
                    : row[col.accessor]}
                </ColumnCell>
              ))}
            </div>
          ))}
          {/* <ReactTable
                data={sorted}
                columns={columns}
                defaultSorted={[{
                    id: 'closingDate',
                    desc: true,
                }]}
            /> */}
        </div>
      )}
    </div>
  );
};

const ColumnHeading = styled.div`
  font-weight: bold;
  width: 250px;
  padding: 5px;
  font-size: 16px;
  border-left: 1px solid #cacaca;
  border-bottom: 1px solid #cacaca;
`;

const ColumnCell = styled.div`
  width: 250px;
  padding: 5px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-left: 1px solid #cacaca;
  border-bottom: 1px solid #cacaca;
`;

export default Main;



// WEBPACK FOOTER //
// ./src/admin/components/Database.js